import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
import productAntiqueAuto from './product-antiqueauto.png'

export const meta: MetaFunction = () => [
	{ title: 'Antique Car Insurance' },
	{
		name: 'description',
		content: 'We offer Antique Car Insurance.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Antique Car Insurance</h1>
			<img
				src={productAntiqueAuto}
				alt="An antique car parked in front of a building."
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Collectible, Classic, or Exotic cars can qualify for special coverage on
				a special policy designed to cover this type of vehicle.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Related Products:
				<ul>
					<li>
						<Link
							to="/products-and-programs/auto-insurance"
							className="text-blue-600 underline"
							prefetch="intent"
						>
							{' '}
							Auto Insurance
						</Link>
					</li>
				</ul>
			</p>
		</main>
	)
}
